import { BackgroundVisitUploadStatus } from "@/common/enums/backgroundVisitUploadStatus";
import { useBackgroundVisitUploadStore } from "@/store/backgroundVisitUpload.store";

export const useBackgroundVisitStatus = (): {
  unfinishedCount: number;
  isUploading: boolean;
} => {
  const uploads = useBackgroundVisitUploadStore((state) => state.uploads);

  const unfinishedCount = uploads.filter(
    (upload) =>
      upload.status === BackgroundVisitUploadStatus.PENDING ||
      upload.status === BackgroundVisitUploadStatus.UPLOADING
  ).length;

  const isUploading = uploads.some(
    (upload) => upload.status === BackgroundVisitUploadStatus.UPLOADING
  );

  return { unfinishedCount, isUploading };
};
